import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef, memo } from "react";
const SvgYouTube = ({ title, titleId, ...props }, ref)=>/*#__PURE__*/ jsxs("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        role: "img",
        ref: ref,
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ jsx("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ jsx("path", {
                d: "M22.5398 6.42092C22.4155 5.95275 22.1704 5.52546 21.8291 5.18182C21.4877 4.83819 21.062 4.59028 20.5947 4.46292C18.8796 4 12 4 12 4C12 4 5.12042 4 3.40442 4.46292C2.93729 4.5905 2.51185 4.83851 2.17065 5.18212C1.82946 5.52573 1.58446 5.9529 1.46017 6.42092C1 8.14792 1 11.7504 1 11.7504C1 11.7504 1 15.3529 1.46017 17.0799C1.58445 17.5481 1.82956 17.9754 2.17094 18.319C2.51232 18.6626 2.938 18.9106 3.40533 19.0379C5.12042 19.5008 12 19.5008 12 19.5008C12 19.5008 18.8796 19.5008 20.5956 19.0379C21.063 18.9106 21.4887 18.6628 21.8301 18.3191C22.1715 17.9755 22.4165 17.5481 22.5408 17.0799C23 15.3529 23 11.7504 23 11.7504C23 11.7504 23 8.14792 22.5398 6.42092ZM9.74958 15.0211V8.47975L15.4998 11.7504L9.74958 15.0211Z",
                fill: "currentColor"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ forwardRef(SvgYouTube);
const Memo = /*#__PURE__*/ memo(ForwardRef);
const YouTube = Memo;
export { YouTube as default };
